import { render } from "./partner-spare-part-search.vue?vue&type=template&id=1caf4f1b&ts=true"
import script from "./partner-spare-part-search.vue?vue&type=script&lang=ts"
export * from "./partner-spare-part-search.vue?vue&type=script&lang=ts"

import "./partner-spare-part-search.vue?vue&type=style&index=0&id=1caf4f1b&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__